import type * as ents from '@attain-apps/entities'

/** State for document operations belonging to one knowledge-base collection. */
export interface State {
  /** Selected deletion and its current request state. */
  readonly deletion: FileOperation<true> | undefined
  /** Download request state keyed by the document's object key. */
  readonly downloads: EntryLookup<string>
  /** Current upload request state. */
  readonly upload: Entry<void> | undefined
}

/** Data, loading, or failure produced by one document operation. */
type Entry<TData> = ExactlyOneOf<{
  readonly data: TData
  readonly loading: true
  readonly error: Error
}>

/** Operation entry associated with a selected knowledge-base document. */
interface FileOperation<TData> {
  readonly entry?: Entry<TData>
  readonly fileKey: ents.core.agent.KnowledgeBase.Management.Key
}

/** Operation entries addressed by knowledge-base document key. */
type EntryLookup<TData> = Readonly<
  Partial<Record<ents.core.agent.KnowledgeBase.Management.Key, Entry<TData>>>
>

export namespace State {
  /** Initial document-operation state for a knowledge-base collection. */
  export const INITIAL: Readonly<State> = {
    deletion: undefined,
    downloads: {},
    upload: undefined,
  }
}
